import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AssetVersionPipe } from '../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-coming-soon',
  imports: [NgClass, AssetVersionPipe],
  templateUrl: './coming-soon.component.html',
  styleUrl: './coming-soon.component.scss'
})
export class ComingSoonComponent {
  @Input() isVisible?: boolean = false;
  @Input() triangleOffset?: number = 0;
  @Input() trianglePosition?: 'left' | 'right' | 'top' | 'bottom' = 'top';
}
